import { render, staticRenderFns } from "./PageTitleArea.vue?vue&type=template&id=e030a70c&"
import script from "./PageTitleArea.vue?vue&type=script&lang=js&"
export * from "./PageTitleArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports